import "./row-options.scss";

import classNames from "classnames";
import React, { useState } from "react";
import Popup from "reactjs-popup";
import { v4 as uuidv4 } from "uuid";

import { IconButton, Typography } from "@/components/Elements";

export type Option = {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  disabledTooltip?: string;
};

type RowOptionsProps = {
  options: Array<Option>;
  disabled?: boolean;
  disabledTooltip?: string;
};

const RowOptions = ({
  options,
  disabled = false,
  disabledTooltip = "",
}: RowOptionsProps) => {
  const [isOpen, setIsOpen] = useState(false);
  if (options.length === 0) {
    return null;
  }

  const onClick = (option: Option) => {
    option?.onClick();
    setIsOpen(false);
  };

  if (disabled) {
    return (
      <div
        data-tooltip-id="tooltip"
        data-tooltip-place="right"
        data-tooltip-content={disabledTooltip}
      >
        <IconButton active={isOpen} icon="moreVertical" disabled />
      </div>
    );
  }

  return (
    <div className="row-options">
      <Popup
        position="left top"
        trigger={
          <div>
            <IconButton active={isOpen} icon="moreVertical" />
          </div>
        }
        open={isOpen}
        onOpen={() => setIsOpen(true)}
        onClose={() => setIsOpen(false)}
        closeOnDocumentClick
        closeOnEscape
      >
        <div className="row-options__list">
          {options.map((option) => (
            <button
              key={uuidv4()}
              className={classNames("row-options__option", {
                "row-options__option__disabled": option.disabled,
              })}
              type="button"
              onClick={() => onClick(option)}
              disabled={option.disabled}
              data-tooltip-id="tooltip"
              data-tooltip-place="left"
              data-tooltip-content={option.disabledTooltip}
            >
              <Typography
                label={option.label}
                size="sm"
                color={
                  option.disabled
                    ? "extrasBlueGrayDarker"
                    : "generalMidnightDark"
                }
                weight="semiBold"
              />
            </button>
          ))}
        </div>
      </Popup>
    </div>
  );
};

export default RowOptions;
